module.exports = __webpack_public_path__ + "img/homebtn22.9e50bb5b.png";